import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";

import { MenuIcon } from "components/Icons";

export const FlaggedAccountMenu = ({ account, handleUpdateAccount }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const _handleAccountUpdate = () => {
    handleUpdateAccount(account);
    handleClose();
  };

  return (
    <div>
      <MenuIcon onClick={handleClick} />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {" "}
        {Boolean(account) && (
          <MenuItem onClick={_handleAccountUpdate} sx={{ fontSize: "13px" }}>
            {account.status ? "Remove Restriction" : "Flag Account"}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};
